// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader__1INrZ","spin":"spin__18z5h"};


//////////////////
// WEBPACK FOOTER
// ./components/loader/loader.css
// module id = FgT3
// module chunks = 0